export default __webpack_public_path__ + "static/media/sooldamhwa-main-logo.b5501f68.png";